import React, { useState } from 'react';
import { Checkbox } from 'antd';
import { EyeOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { ANNOTATION_CATEGORIES } from './AnnotationIcons';

const AnnotationSidePanel = ({
  hiddenCategories,
  onToggleCategory,
  showLegend,
  onToggleLegend,
  showToolbar,
  onToggleToolbar,
}) => {
  const [panelCollapsed, setPanelCollapsed] = useState(false);

  return (
    <div style={{
      width: 240,
      background: 'white',
      borderRadius: 8,
      boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 16px 8px',
        borderBottom: panelCollapsed ? 'none' : '1px solid #f0f0f0',
        cursor: 'pointer',
      }} onClick={() => setPanelCollapsed(v => !v)}>
        <span style={{ fontWeight: 600, fontSize: 13, color: '#111827' }}>Annotations</span>
        {panelCollapsed
          ? <PlusOutlined style={{ fontSize: 12, color: '#6b7280' }} />
          : <MinusOutlined style={{ fontSize: 12, color: '#6b7280' }} />
        }
      </div>

      {/* Body */}
      {!panelCollapsed && (
        <div style={{ padding: '8px 16px 12px' }}>
          {ANNOTATION_CATEGORIES.map(cat => (
            <div
              key={cat.key}
              style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7, cursor: 'pointer' }}
              onClick={() => onToggleCategory(cat.key)}
            >
              <Checkbox
                checked={!hiddenCategories.includes(cat.key)}
                onChange={() => onToggleCategory(cat.key)}
                onClick={e => e.stopPropagation()}
              />
              <span style={{ fontSize: 13, color: '#374151', userSelect: 'none' }}>{cat.label}</span>
            </div>
          ))}

          {/* Drawing Tools toggle */}
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7, cursor: 'pointer' }}
            onClick={onToggleToolbar}
          >
            <Checkbox
              checked={showToolbar}
              onChange={onToggleToolbar}
              onClick={e => e.stopPropagation()}
            />
            <span style={{ fontSize: 13, color: '#374151', userSelect: 'none' }}>Drawing Tools</span>
          </div>

          {/* Show Legend */}
          <div
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              cursor: 'pointer', marginTop: 6,
              paddingTop: 8, borderTop: '1px solid #f3f4f6',
            }}
            onClick={onToggleLegend}
          >
            <EyeOutlined style={{ fontSize: 14, color: showLegend ? '#0d3825' : '#9ca3af' }} />
            <span style={{ fontSize: 13, color: showLegend ? '#0d3825' : '#6b7280', userSelect: 'none' }}>
              Show Legend
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnotationSidePanel;
